export default __webpack_public_path__ + "static/customer-d6848a7cc15cbcdc1c25ce639e1c6c6a.png";